









































































































































































































































































































































































































































































import Vue from 'vue'
import ElementMixin from './ElementMixin'
import { stubString } from 'lodash'

export default Vue.extend({
  mixins: [ElementMixin],
})
